var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMushroomColIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.93 94.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.93,
    height: 94.93,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.22,31.91c0-12-15.11-21.8-33.75-21.8s-33.76,9.76-33.76,21.8a14.47,14.47,0,0,0,1.11,5.55h0c.49,3.47,14.86,6.26,32.54,6.26s32.05-2.79,32.54-6.26h.19A14.47,14.47,0,0,0,81.22,31.91Z",
    style: {
      fill: "#f94230"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.38,43.72c-4.38,0-8.55-.17-12.37-.48-2,12.81-4.41,25.82-2.57,39h0c0,1.65,6.79,3,15.17,3s15.17-1.35,15.17-3h0c1.29-13.83-1.1-26.93-2.62-39C56.23,43.54,51.92,43.72,47.38,43.72Z",
    style: {
      fill: "#a38066"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.38,52.54a60.75,60.75,0,0,0,13.83-1.4c-.36-2.69-.73-5.34-1.05-7.94-3.93.34-8.24.52-12.78.52-4.38,0-8.55-.17-12.37-.48-.42,2.63-.85,5.27-1.26,7.92A60.48,60.48,0,0,0,47.38,52.54Z",
    style: {
      fill: "#84644e"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.41,
    cy: 20.89,
    rx: 1.75,
    ry: 2.8,
    transform: "translate(21.85 73.14) rotate(-69.73)",
    style: {
      fill: "#f4eae4"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.04,
    cy: 20.89,
    rx: 4.11,
    ry: 2.57,
    transform: "matrix(0.97, -0.25, 0.25, 0.97, -3.95, 11.07)",
    style: {
      fill: "#f4eae4"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.75,
    cy: 12.73,
    rx: 2.8,
    ry: 1.1,
    transform: "translate(-1.16 4.86) rotate(-6.42)",
    style: {
      fill: "#f4eae4"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.53,
    cy: 26.26,
    rx: 3.76,
    ry: 4.54,
    transform: "translate(15.1 71.85) rotate(-76)",
    style: {
      fill: "#f4eae4"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMushroomColIcon);
export default __webpack_public_path__ + "static/media/mushroom_col_icon.4f1ac986ad9f6f1b2af9c10b1df00579.svg";
export { ForwardRef as ReactComponent };